import React from "react";
import toast from "react-hot-toast";
import withProviders from "../../../hooks/withProviders";
import { oidcClient } from "../../../redux/token";
import { GenericLayoutPageSubHeader, Main } from "../../../components/utilities";
import { MicroserviceManagementProvider, MicroserviceActionsDropdown, MicroserviceActionsDropdownItem, MicroserviceStatusDisplay } from "../../../features/microservicemanagement";
import { MicroserviceEventsTable } from "../../../features/microserviceeventstable";
import { useLazyFetchIdentityMicroserviceEventsQuery } from "../../../services/identity";

export const IdentityMicroserviceManagementPage = withProviders([
    MicroserviceManagementProvider, {
        healthEndpoint: '/api/identity/health',
        seedEndpoint: null
    }
])(({ syncEndpoint = "/api/identity/system/tools/sync" }: Readonly<{ syncEndpoint?: string }>) => {

    const executeSyncWithKeycloak = () => {
        let tokenData = oidcClient.getOidcToken();
        fetch(syncEndpoint, {
            method: 'POST',
            headers: {
                'Authorization': `${tokenData?.token_type} ${tokenData?.access_token}`,
                'Content-Type': 'application/json'
            },
            body: ""
        })
            .then(() => toast('Sync with Keycloak Job has started.'))
            .catch(() => toast.error('Failed to start the Sync with keycloak Job.'));
    };

    return (
        <Main className="d-flex flex-column">
            <GenericLayoutPageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <MicroserviceStatusDisplay />
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center">
                        <MicroserviceActionsDropdown>
                            <MicroserviceActionsDropdownItem icon={['fas', 'sync']} onClick={executeSyncWithKeycloak} text="Sync with Keycloak" />
                        </MicroserviceActionsDropdown>
                    </div>
                </div>
            </GenericLayoutPageSubHeader>
            <section className="px-4 my-3 h-100">
                <MicroserviceEventsTable query={useLazyFetchIdentityMicroserviceEventsQuery} />
            </section>
        </Main>
    );
});